export default {
  choise: '请选择',
  enter: '请输入内容',
  show: '预览',
  edit: '备注',
  submit: '提交',
  close: '关闭',
  groupTemp1:	'上文(辅助：无需转写)',
  groupTemp2:	'下文(辅助：无需转写)'
}



// WEBPACK FOOTER //
// ./src/lang/zh/group.js